import styled from 'styled-components'
import PropTypes from 'prop-types'

const CrumbContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0;
`

const Crumb = styled.div`
  display: flex;
  align-items: center;
  background: #f3f4f6;
  border-radius: 16px;
  padding: 4px 12px 4px 8px;
  font-size: 15px;
  color: #333;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: background 0.2s;
  gap: 7px;
`

const RemoveIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #888;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #d32f2f;
  }
`

const FiltersBreadCrumbs = ({ crumbs = [], onRemove }) => {
  return (
    <CrumbContainer>
      {crumbs.map((crumb, idx) => (
        <Crumb key={idx} onClick={() => onRemove && onRemove(crumb)}>
          {crumb.label || crumb}
          <RemoveIcon aria-label="Remove">✕</RemoveIcon>
        </Crumb>
      ))}
    </CrumbContainer>
  )
}

FiltersBreadCrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
      })
    ])
  ),
  onRemove: PropTypes.func
}

export default FiltersBreadCrumbs
